module.exports = __webpack_public_path__ + "static/media/logo5.3de091e4.jpg";